module.exports = __webpack_public_path__ + "48ca02e499fcca086e8ebe23b08b17d4.jpg";